import React, { useContext, useEffect, useState } from "react";
import { CardContainer, CardDashboardAdmin, Container } from "components";
import { menuAdmin } from "constants/menu";
import Breadcrumb from "components/molecules/Breadcrumb";
import { AuthContext } from "context/AuthContext";
import { useNavigate } from "react-router-dom";

const DashboardAdmin = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);

  const kbSubMenu = menuAdmin
    .find((item) => item.title === "Settings")
    .sub.find((item) => item.title === "Knowledge Base");

  const kbSubMenuItems = kbSubMenu.sub
    .map((item) => ({
      title: item.title,
      icons: item.icon,
      hidden: item.hidden,
      path: `knowledgebase/${item.path}`,
    }))
    .filter((item) => item.hidden !== true);

  const staffSubMenu = menuAdmin
    .find((item) => item.title === "Settings")
    .sub.find((item) => item.title === "Staff");

  const staffSubMenuItems = staffSubMenu.sub
    .map((item) => ({
      title: item.title,
      icons: item.icon,
      hidden: item.hidden,
      path: `staff/${item.path}`,
    }))
    .filter((item) => item.hidden !== true);

  const emailSubMenu = menuAdmin
    .find((item) => item.title === "Settings")
    .sub.find((item) => item.title === "Email");

  const emailSubMenuItems = emailSubMenu.sub
    .map((item) => ({
      title: item.title,
      icons: item.icon,
      hidden: item.hidden,
      path: `email/${item.path}`,
    }))
    .filter((item) => item.hidden !== true);

  const manageSubMenu = menuAdmin
    .find((item) => item.title === "Settings")
    .sub.find((item) => item.title === "Manage");

  const manageSubMenuItems = manageSubMenu.sub
    .map((item) => ({
      title: item.title,
      icons: item.icon,
      hidden: item.hidden,
      path: `manage/${item.path}`,
    }))
    .filter((item) => item.hidden !== true);

  const ticketSubMenu = menuAdmin
    .find((item) => item.title === "Settings")
    .sub.find((item) => item.title === "Tickets");

  const ticketSubMenuItems = ticketSubMenu.sub
    .map((item) => ({
      title: item.title,
      icons: item.icon,
      hidden: item.hidden,
      path: `tickets/${item.path}`,
    }))
    .filter((item) => item.hidden !== true);

  const settingSubMenu = menuAdmin
    .find((item) => item.title === "Settings")
    .sub.find((item) => item.title === "Setting");

  const settingSubMenuItems = settingSubMenu.sub
    .map((item) => ({
      title: item.title,
      icons: item.icon,
      hidden: item.hidden,
      path: `setting/${item.path}`,
    }))
    .filter((item) => item.hidden !== true);

  const errorlogsdebuggingSubMenu = menuAdmin
    .find((item) => item.title === "Settings")
    .sub.find((item) => item.title === "Error Logs & Debugging");

  const errorlogsdebuggingSubMenuItems = errorlogsdebuggingSubMenu.sub
    .map((item) => ({
      title: item.title,
      icons: item.icon,
      hidden: item.hidden,
      path: `errorlogsdebugging/${item.path}`,
    }))
    .filter((item) => item.hidden !== true);

  // const widgetsSubMenu = menuAdmin
  //   .find((item) => item.title === "Settings")
  //   .sub.find((item) => item.title === "Widget");

  // const widgetsSubMenuItems = widgetsSubMenu.sub
  //   .map((item) => ({
  //     title: item.title,
  //     icons: item.icon,
  //     hidden: item.hidden,
  //     path: `widget/${item.path}`,
  //   }))
  //   .filter((item) => item.hidden !== true);

  const SubMenu = menuAdmin.find((item) => item.title === "Settings");

  // const apiSubMenuItems = SubMenu.sub
  //   .map((item) => ({
  //     title: item.title,
  //     icons: item.icon,
  //     path: item.path,
  //   }))
  //   .filter((item) => item.title === "API");

  const logsSubMenuItems = SubMenu.sub
    .map((item) => ({
      title: item.title,
      icons: item.icon,
      path: item.path,
    }))
    .filter((item) => item.title === "Logs");

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );

      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Admin Panel"}
        excludedPaths={["dashboardadmin", "dashboard", "administrator"]}
        group={"Superadmin"}
      />
      <div className="mt-4">
        <CardContainer title="Knowledge Base">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {kbSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div>
      <div className="mt-4">
        <CardContainer title="Staff">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {staffSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div>
      <div className="mt-4">
        <CardContainer title="Email">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {emailSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div>
      <div className="mt-4">
        <CardContainer title="Manage">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {manageSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div>
      <div className="mt-4">
        <CardContainer title="Ticket">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {ticketSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div>
      <div className="mt-4">
        <CardContainer title="Setting">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {settingSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div>
      <div className="mt-4">
        <CardContainer title="Error logs and debugging">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {errorlogsdebuggingSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div>
      {/* <div className="mt-4">
        <CardContainer title="Widgets">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {widgetsSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div> */}
      {/* <div className="mt-4">
        <CardContainer title="API">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {apiSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div> */}
      <div className="mt-4">
        <CardContainer title="Logs">
          <div className="p-4">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
              {logsSubMenuItems.map((item, index) => (
                <CardDashboardAdmin key={index} {...item} />
              ))}
            </div>
          </div>
        </CardContainer>
      </div>
    </Container>
  );
};

export default DashboardAdmin;
